export default __webpack_public_path__ + "static/media/manage_users.a93bbe0f.svg";